<template>
    <router-link
        active-class="rounded shadow-lg text-blue-500 bg-white transform-none | hover:text-blue-500"
        class="w-full px-3 py-3 | transition duration-300 | hover:text-gray-900"
        :to="to"
    >
        <slot />
    </router-link>
</template>

<script>
    export default {
        props: {
            to: {
                type: [String, Object],
                required: true,
            },
        },
    };
</script>
